import Col from "@visa/vds/col";
import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import React from "react";
import MCSReadonlyField from "../../../components/MCSReadonlyField";

const DafTabThreeRequestDetails = (props) => {
  let tabThreeRequest = props.tabThreeRequest;
  if (!tabThreeRequest) return <></>;
  return (
    <>
      <Grid>
        <Row noGutter key={1}>
          <Col noTopGutter noGutter lg={6}>
            <MCSReadonlyField label="Record#" text={tabThreeRequest.recordNo} />
          </Col>
          <Col noTopGutter noGutter lg={6}>
            <MCSReadonlyField
              label="Visa Access User ID"
              text={tabThreeRequest.volUserId}
            />
          </Col>
        </Row>
        <Row noGutter>
          <Col noTopGutter noGutter lg={6}>
            <MCSReadonlyField
              label="Acquirer First Name"
              text={tabThreeRequest.acquirerFirstName}
            />
          </Col>
          <Col noTopGutter noGutter lg={6}>
            <MCSReadonlyField
              label="Acquirer Last Name"
              text={tabThreeRequest.acquirerLastName}
            />
          </Col>
        </Row>
        <Row noGutter>
          <Col noTopGutter noGutter lg={6}>
            <MCSReadonlyField
              label="Acquirer Role/Title"
              text={tabThreeRequest.acquirerRoleOrTitle}
            />
          </Col>
          <Col noTopGutter noGutter lg={6}>
            <MCSReadonlyField
              label="Acquirer Country"
              text={tabThreeRequest.acquirerCountry}
            />
          </Col>
        </Row>
        <Row noGutter>
          <Col noTopGutter noGutter lg={6}>
            <MCSReadonlyField
              label="Acquirer Email"
              text={tabThreeRequest.acquirerEmail}
            />
          </Col>
          <Col noTopGutter noGutter lg={6}>
            <MCSReadonlyField
              label="Acquirer Phone Number"
              text={tabThreeRequest.acquirerPhoneNumber}
            />
          </Col>
        </Row>
        <Row noGutter>
          <Col noTopGutter noGutter lg={12}>
            <MCSReadonlyField
              label="VSS Acquirer Processing Result"
              text={tabThreeRequest.processResultName}
            />
          </Col>
        </Row>
        <Row noGutter>
          <Col noTopGutter noGutter lg={6}>
            <MCSReadonlyField
              label="Visa Contact First Name"
              text={tabThreeRequest.visaContactFirstName}
            />
          </Col>
          <Col noTopGutter noGutter lg={6}>
            <MCSReadonlyField
              label="Visa Contact Last Name"
              text={tabThreeRequest.visaContactLastName}
            />
          </Col>
        </Row>
        <Row noGutter>
          <Col noTopGutter noGutter lg={6}>
            <MCSReadonlyField
              label="Visa Contact Email"
              text={tabThreeRequest.visaContactEmail}
            />
          </Col>
          <Col noTopGutter noGutter lg={6}></Col>
        </Row>
      </Grid>
    </>
  );
};
export default DafTabThreeRequestDetails;
